import { WebsiteRedirectSourceTypeEnum } from '@jove-frontend/enums';
import { getBusinessInsuranceLandingPageThemeMap, getSupportRegionMap, goodsInTransitOldCompatibilityKey, supportTranslationCountryConvertMap } from '@jove-frontend/uikit';
export var useBrokerProductLink = function useBrokerProductLink() {
  var getBrokerProductLandingPageUrl = function getBrokerProductLandingPageUrl(config) {
    var _config$landingPageTh, _config$regions, _config$regions2, _config$countries;

    var insurancePath = 'business-insurance';

    if ((config === null || config === void 0 ? void 0 : config.insuranceType) === goodsInTransitOldCompatibilityKey) {
      insurancePath = 'goods-in-transit';
    } else {
      switch (config === null || config === void 0 ? void 0 : (_config$landingPageTh = config.landingPageThemes) === null || _config$landingPageTh === void 0 ? void 0 : _config$landingPageTh[0]) {
        case getBusinessInsuranceLandingPageThemeMap().commercial.value:
          insurancePath = 'commercial-combined-business';
          break;

        case getBusinessInsuranceLandingPageThemeMap().recruitment.value:
          insurancePath = 'recruitment';
          break;

        default:
          insurancePath = 'business-insurance';
          break;
      }
    }

    var params = new URLSearchParams();
    params.append('sourceType', WebsiteRedirectSourceTypeEnum.landingPage);
    params.append('slug', config === null || config === void 0 ? void 0 : config.slug);
    params.append('insurancePath', insurancePath);

    if ((config === null || config === void 0 ? void 0 : (_config$regions = config.regions) === null || _config$regions === void 0 ? void 0 : _config$regions.length) === 1 && config !== null && config !== void 0 && (_config$regions2 = config.regions) !== null && _config$regions2 !== void 0 && _config$regions2.includes(getSupportRegionMap().EU.value) && (config === null || config === void 0 ? void 0 : (_config$countries = config.countries) === null || _config$countries === void 0 ? void 0 : _config$countries.length) > 0) {
      var _supportTranslationCo, _supportTranslationCo2, _supportTranslationCo3, _countryItem$code;

      var countryItem = config.countries[0];
      var language = !!((_supportTranslationCo = supportTranslationCountryConvertMap[countryItem.code]) !== null && _supportTranslationCo !== void 0 && _supportTranslationCo.locale) && ((_supportTranslationCo2 = supportTranslationCountryConvertMap[countryItem.code]) === null || _supportTranslationCo2 === void 0 ? void 0 : _supportTranslationCo2.locale) !== 'en' ? (_supportTranslationCo3 = supportTranslationCountryConvertMap[countryItem.code]) === null || _supportTranslationCo3 === void 0 ? void 0 : _supportTranslationCo3.locale : '';
      var country = (_countryItem$code = countryItem.code) === null || _countryItem$code === void 0 ? void 0 : _countryItem$code.toUpperCase();

      if (country) {
        params.append('country', country);
      }

      if (language) {
        params.append('language', language.toLowerCase());
      }
    } else {
      var _config$regions3, _config$regions4;

      if (config !== null && config !== void 0 && (_config$regions3 = config.regions) !== null && _config$regions3 !== void 0 && _config$regions3.includes(getSupportRegionMap().US.value)) {
        params.append('country', getSupportRegionMap().US.value);
      } else if (config !== null && config !== void 0 && (_config$regions4 = config.regions) !== null && _config$regions4 !== void 0 && _config$regions4.includes(getSupportRegionMap().GB.value)) {
        params.append('country', getSupportRegionMap().GB.value);
      }
    }

    return "".concat(process.env['NX_WEBSITE_URL'], "/redirect/broker-landing?").concat(params.toString());
  };

  return {
    getBrokerProductLandingPageUrl: getBrokerProductLandingPageUrl
  };
};